import Vue from 'vue'
import App from './App.vue'
import router from './router'
import swiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {get, post} from './lib/axios'
import {getCookie, setCookie, delCookie} from './lib/cookie'
import global_ from './lib/config'
import './assets/icon/font_1097529_pqzt0s64kx/iconfont.css'
import Share from 'vue-social-share'
import './assets/css/client.css';

// 接口信息
import * as ServicesApi from './config/api';
Vue.prototype.ServicesApi = ServicesApi;

Vue.use(swiper)

// 社交分享
Vue.use(Share)

//饿了么UI
Vue.use(ElementUI);
// axios
Vue.prototype.$get = get
Vue.prototype.$post = post
// cookie
Vue.prototype.getCookie = getCookie
Vue.prototype.setCookie = setCookie
Vue.prototype.delCookie = delCookie


Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App),
    watch: {
        $route() {
            document.title = global_.WEB_NAME + this.$route.meta.title
        }
    }
}).$mount('#app')
